import { gql } from '@apollo/client/core'

export const ANNOUNCEMENT_FRAGMENT = gql`
  fragment Announcement on Announcement {
    id
    clubId
    eventId
    startDate
    endDate
    position
    content
  }
`
